import { render, staticRenderFns } from "./InboxPage.vue?vue&type=template&id=862ec3e4&"
import script from "./InboxPage.vue?vue&type=script&lang=js&"
export * from "./InboxPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('862ec3e4')) {
      api.createRecord('862ec3e4', component.options)
    } else {
      api.reload('862ec3e4', component.options)
    }
    module.hot.accept("./InboxPage.vue?vue&type=template&id=862ec3e4&", function () {
      api.rerender('862ec3e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/InboxPage.vue"
export default component.exports